import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import i18n from 'i18n';
import { toastr } from 'utils';
import PLANS_KEYS from '../plans.keys';
import PLANS_MUTATIONS from '../plans.mutations';
import PLANS_QUERIES from '../plans.queries';

export const useFetchPlans = () =>
  useQuery({
    queryKey: PLANS_KEYS.PLANS(),
    queryFn: () => PLANS_QUERIES.FETCH_PLANS(),
    staleTime: 1 * 60 * 1000,
  });

export const useCreatePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PLANS_MUTATIONS.CREATE_PLAN,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PLANS_KEYS.PLANS() });
      toastr.success(i18n.t('toastr:success'), i18n.t('toastr:planCreatedSuccessfully'));
    },
  });
};

export const useUpdatePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PLANS_MUTATIONS.UPDATE_PLAN,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PLANS_KEYS.PLANS() });
      toastr.success(i18n.t('toastr:success'), i18n.t('toastr:planUpdatedSuccessfully'));
    },
  });
};

export const useDeletePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: PLANS_MUTATIONS.DELETE_PLAN,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PLANS_KEYS.PLANS() });
      toastr.success(i18n.t('toastr:success'), i18n.t('toastr:planDeletedSuccessfully'));
    },
  });
};
